// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════
   PanelExcepcion
   ═══════════════════════════════════════════════ */
.pe-panel {
  position: relative;
  top: calc(10% + 280px); /* queda justo debajo de PanelCorrelaciones */
  /* right: 3%; */
  z-index: 10;

  width: 252px;
  background: #ffffff;
  border: 1.5px solid var(--second-color);
  border-radius: 12px;
  overflow: hidden;
  font-family: sans-serif;
  font-size: 13px;
  color: #1a1a1a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10);
}

/* ── Header ─────────────────────────────────────── */
.pe-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  cursor: pointer;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.08);
  -webkit-user-select: none;
          user-select: none;
}
.pe-header:hover { background: rgba(0, 0, 0, 0.03); }

.pe-title {
  font-size: 13px;
  font-weight: 500;
  color: #1a1a1a;
}
.pe-header-right {
  display: flex;
  align-items: center;
  gap: 6px;
}
.pe-count-badge {
  background: #EEEDFE;
  color: #534AB7;
  font-size: 10px;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 6px;
}
.pe-toggle {
  font-size: 14px;
  color: #888;
  line-height: 1;
}

/* ── Hint ────────────────────────────────────────── */
.pe-hint {
  padding: 5px 14px;
  font-size: 11px;
  color: #888;
  background: #fafafa;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.06);
  line-height: 1.4;
}

/* ── Cuerpo ──────────────────────────────────────── */
.pe-body {
  padding: 10px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* ── Formulario ──────────────────────────────────── */
.pe-form {
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.pe-field {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.pe-label {
  font-size: 11px;
  color: #888;
}
.pe-select,
.pe-input {
  background: #f5f5f5;
  color: #1a1a1a;
  border: 0.5px solid rgba(0, 0, 0, 0.14);
  border-radius: 8px;
  padding: 7px 10px;
  font-size: 12px;
  width: 100%;
  outline: none;
  box-sizing: border-box;
}
.pe-select { cursor: pointer; appearance: auto; }
.pe-input::placeholder { color: #aaa; }
.pe-select:focus,
.pe-input:focus {
  border-color: rgba(83, 74, 183, 0.5);
  box-shadow: 0 0 0 3px rgba(83, 74, 183, 0.1);
}

/* ── Selector de color (pills) ───────────────────── */
.pe-color-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.pe-color-pill {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid transparent;
  cursor: pointer;
  transition: transform 0.12s;
  padding: 0;
}
.pe-color-pill:hover          { transform: scale(1.1); }
.pe-color-pill--active {
  border-color: rgba(0, 0, 0, 0.35);
  transform: scale(1.18);
}
.pe-color-name {
  font-size: 11px;
  color: #888;
  margin-left: 2px;
}

/* ── Botón crear ─────────────────────────────────── */
.pe-btn-crear {
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px;
  font-size: 12px;
  font-weight: 500;
  width: 100%;
  cursor: pointer;
  transition: opacity 0.15s, transform 0.1s;
  margin-top: 2px;
}
.pe-btn-crear:hover  { opacity: 0.88; }
.pe-btn-crear:active { transform: scale(0.97); }

/* ── Lista de excepciones ────────────────────────── */
.pe-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-height: 160px;
  overflow-y: auto;
  border-top: 0.5px solid rgba(0, 0, 0, 0.07);
  padding-top: 8px;
}
.pe-list::-webkit-scrollbar       { width: 3px; }
.pe-list::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.15); border-radius: 2px; }

.pe-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background: #f5f5f5;
  border-radius: 8px;
  padding: 6px 10px;
  border-left-width: 3px;
  border-left-style: solid;
}
.pe-item-content {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1 1;
  min-width: 0;
}
.pe-item-host {
  font-size: 11px;
  color: #555;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.pe-item-badge {
  display: inline-block;
  font-size: 10px;
  font-weight: 500;
  padding: 1px 6px;
  border-radius: 4px;
  width: -moz-fit-content;
  width: fit-content;
}
.pe-item-delete {
  background: none;
  border: none;
  color: #aaa;
  cursor: pointer;
  font-size: 12px;
  padding: 0 2px;
  flex-shrink: 0;
  transition: color 0.15s;
}
.pe-item-delete:hover { color: #E24B4A; }
`, "",{"version":3,"sources":["webpack://./src/components/styles/PanelExcepciones.css"],"names":[],"mappings":"AAAA;;oDAEoD;AACpD;EACE,kBAAkB;EAClB,sBAAsB,EAAE,6CAA6C;EACrE,eAAe;EACf,WAAW;;EAEX,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,yCAAyC;AAC3C;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,8CAA8C;EAC9C,yBAAiB;UAAjB,iBAAiB;AACnB;AACA,mBAAmB,+BAA+B,EAAE;;AAEpD;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;;EAEE,mBAAmB;EACnB,cAAc;EACd,uCAAuC;EACvC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;AACA,aAAa,eAAe,EAAE,gBAAgB,EAAE;AAChD,yBAAyB,WAAW,EAAE;AACtC;;EAEE,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,2BAA2B;EAC3B,UAAU;AACZ;AACA,gCAAgC,qBAAqB,EAAE;AACvD;EACE,iCAAiC;EACjC,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yCAAyC;EACzC,eAAe;AACjB;AACA,uBAAuB,aAAa,EAAE;AACtC,uBAAuB,sBAAsB,EAAE;;AAE/C,uDAAuD;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;EAC3C,gBAAgB;AAClB;AACA,oCAAoC,UAAU,EAAE;AAChD,oCAAoC,4BAA4B,EAAE,kBAAkB,EAAE;;AAEtF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;AACA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;EACd,uBAAuB;AACzB;AACA,wBAAwB,cAAc,EAAE","sourcesContent":["/* ═══════════════════════════════════════════════\r\n   PanelExcepcion\r\n   ═══════════════════════════════════════════════ */\r\n.pe-panel {\r\n  position: relative;\r\n  top: calc(10% + 280px); /* queda justo debajo de PanelCorrelaciones */\r\n  /* right: 3%; */\r\n  z-index: 10;\r\n\r\n  width: 252px;\r\n  background: #ffffff;\r\n  border: 1.5px solid var(--second-color);\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  font-family: sans-serif;\r\n  font-size: 13px;\r\n  color: #1a1a1a;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10);\r\n}\r\n\r\n/* ── Header ─────────────────────────────────────── */\r\n.pe-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 14px;\r\n  cursor: pointer;\r\n  border-bottom: 0.5px solid rgba(0, 0, 0, 0.08);\r\n  user-select: none;\r\n}\r\n.pe-header:hover { background: rgba(0, 0, 0, 0.03); }\r\n\r\n.pe-title {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: #1a1a1a;\r\n}\r\n.pe-header-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n.pe-count-badge {\r\n  background: #EEEDFE;\r\n  color: #534AB7;\r\n  font-size: 10px;\r\n  font-weight: 500;\r\n  padding: 2px 6px;\r\n  border-radius: 6px;\r\n}\r\n.pe-toggle {\r\n  font-size: 14px;\r\n  color: #888;\r\n  line-height: 1;\r\n}\r\n\r\n/* ── Hint ────────────────────────────────────────── */\r\n.pe-hint {\r\n  padding: 5px 14px;\r\n  font-size: 11px;\r\n  color: #888;\r\n  background: #fafafa;\r\n  border-bottom: 0.5px solid rgba(0, 0, 0, 0.06);\r\n  line-height: 1.4;\r\n}\r\n\r\n/* ── Cuerpo ──────────────────────────────────────── */\r\n.pe-body {\r\n  padding: 10px 14px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n/* ── Formulario ──────────────────────────────────── */\r\n.pe-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 7px;\r\n}\r\n.pe-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n}\r\n.pe-label {\r\n  font-size: 11px;\r\n  color: #888;\r\n}\r\n.pe-select,\r\n.pe-input {\r\n  background: #f5f5f5;\r\n  color: #1a1a1a;\r\n  border: 0.5px solid rgba(0, 0, 0, 0.14);\r\n  border-radius: 8px;\r\n  padding: 7px 10px;\r\n  font-size: 12px;\r\n  width: 100%;\r\n  outline: none;\r\n  box-sizing: border-box;\r\n}\r\n.pe-select { cursor: pointer; appearance: auto; }\r\n.pe-input::placeholder { color: #aaa; }\r\n.pe-select:focus,\r\n.pe-input:focus {\r\n  border-color: rgba(83, 74, 183, 0.5);\r\n  box-shadow: 0 0 0 3px rgba(83, 74, 183, 0.1);\r\n}\r\n\r\n/* ── Selector de color (pills) ───────────────────── */\r\n.pe-color-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-wrap: wrap;\r\n}\r\n.pe-color-pill {\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 50%;\r\n  border: 2px solid transparent;\r\n  cursor: pointer;\r\n  transition: transform 0.12s;\r\n  padding: 0;\r\n}\r\n.pe-color-pill:hover          { transform: scale(1.1); }\r\n.pe-color-pill--active {\r\n  border-color: rgba(0, 0, 0, 0.35);\r\n  transform: scale(1.18);\r\n}\r\n.pe-color-name {\r\n  font-size: 11px;\r\n  color: #888;\r\n  margin-left: 2px;\r\n}\r\n\r\n/* ── Botón crear ─────────────────────────────────── */\r\n.pe-btn-crear {\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 8px;\r\n  padding: 8px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  width: 100%;\r\n  cursor: pointer;\r\n  transition: opacity 0.15s, transform 0.1s;\r\n  margin-top: 2px;\r\n}\r\n.pe-btn-crear:hover  { opacity: 0.88; }\r\n.pe-btn-crear:active { transform: scale(0.97); }\r\n\r\n/* ── Lista de excepciones ────────────────────────── */\r\n.pe-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n  max-height: 160px;\r\n  overflow-y: auto;\r\n  border-top: 0.5px solid rgba(0, 0, 0, 0.07);\r\n  padding-top: 8px;\r\n}\r\n.pe-list::-webkit-scrollbar       { width: 3px; }\r\n.pe-list::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.15); border-radius: 2px; }\r\n\r\n.pe-item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  background: #f5f5f5;\r\n  border-radius: 8px;\r\n  padding: 6px 10px;\r\n  border-left-width: 3px;\r\n  border-left-style: solid;\r\n}\r\n.pe-item-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n.pe-item-host {\r\n  font-size: 11px;\r\n  color: #555;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.pe-item-badge {\r\n  display: inline-block;\r\n  font-size: 10px;\r\n  font-weight: 500;\r\n  padding: 1px 6px;\r\n  border-radius: 4px;\r\n  width: fit-content;\r\n}\r\n.pe-item-delete {\r\n  background: none;\r\n  border: none;\r\n  color: #aaa;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  padding: 0 2px;\r\n  flex-shrink: 0;\r\n  transition: color 0.15s;\r\n}\r\n.pe-item-delete:hover { color: #E24B4A; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
